import { Button } from 'components/Button';

interface Props {
  title: string;
  caption?: string;
  iconSrc?: string;
  onClearFilters?: () => void;
  clearFiltersLabel?: string;
  onChangeLocation?: () => void;
  changeLocationLabel?: string;
}

const DEFAULT_ICON_SRC = '/images/my-programs/hour-glass-done.png';
const DEFAULT_CAPTION = 'Try changing or removing some filters or adjusting your location.';

export default function MarketplaceEmptyPlaceholder({
  title,
  caption = DEFAULT_CAPTION,
  iconSrc = DEFAULT_ICON_SRC,
  onClearFilters,
  clearFiltersLabel = 'Clear filters',
  onChangeLocation,
  changeLocationLabel = 'Change location',
}: Props) {
  const hasAnyAction = !!onClearFilters || !!onChangeLocation;

  return (
    <div className="container mx-auto flex flex-col items-center justify-center py-16 text-center">
      {!!iconSrc && <img src={iconSrc} alt="" className="h-6 w-6 shrink-0" />}
      <h3 className="typography-product-subheading mt-4">{title}</h3>
      {!!caption && (
        <p className="typography-product-caption mt-1 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {caption}
        </p>
      )}
      {hasAnyAction && (
        <div className="mt-ds-xl flex gap-3">
          {!!onChangeLocation && (
            <Button
              onClick={onChangeLocation}
              variant="secondary"
              size="md"
              className="whitespace-nowrap"
            >
              {changeLocationLabel}
            </Button>
          )}
          {!!onClearFilters && (
            <Button
              onClick={onClearFilters}
              variant="secondary"
              size="md"
              className="whitespace-nowrap"
            >
              {clearFiltersLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
